import { Component, OnInit, NgModule, Input  } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormsModule, FormArray } from '@angular/forms';
import { CrudService } from './../../../crud/crud.service';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { createAutoCorrectedDatePipe } from 'text-mask-addons';
import { Mensaje } from '../../../mensaje';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import * as moment from 'moment';

@Component({
  selector: 'app-formulario-docente',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit{
  dato: FormGroup;
  datos_grupos:any[] = [{'carreras':['nombre']}];
  autoCorrectedDatePipe: any = createAutoCorrectedDatePipe('yyyy-mm-dd');
  mask = [/[1-2]/, /[0,1,9]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  tab = 1;
  tab2 = 1;
  mensajeResponse: Mensaje = new Mensaje()
  tamano = document.body.clientHeight;
  grupos;
  tieneid;

  @Input() titulo: string;

  carrera_id:number = null;
  descripcion_beca:any = '';
  inscripcion:number = 0;
  reinscripcion:number = 0;
  colegiatura:number = 0;
  beca_inscripcion:number = 0;
  beca_reinscripcion:number = 0;
  beca_colegiatura:number = 0;
  form_disponibilidades_horarios_docentes;
  form_docentes_perfiles_materias;


  niveles;
  carreras_planes;
  materias;

  parametros = {
    pagina: 0,
    limite: 0
  };

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private crud: CrudService, private notificacion: NotificationsService) { }

  ngOnInit() {
    //console.log(moment().format('YYYY-MM-DD H:m:s'))
    this.dato = this.fb.group({
      id: [''],
      tipos_personas_id: [3],
      email: [''],
      username: [''],
      materias_id: [''],
      carreras_planes_id: [''],
      nivel: [1],
      activo:[false],
      nombre:['',[Validators.required]],
      apellido_paterno: ['', [Validators.required]],
      apellido_materno: ['', [Validators.required]],
      sexo: ['M'],
      curp: ['',[Validators.required]],
      disponibilidades_horarios_docentes: this.fb.array([]),
      docentes_perfiles_materias: this.fb.array([]),
      personas_metadatos: this.fb.group({
        //nombre: ['', [Validators.required]], //!<-- se cambio a datos 
        // apellido_paterno: ['', [Validators.required]],
        // apellido_materno: ['', [Validators.required]],
        fecha_nacimiento: ['', [Validators.required,Validators.pattern('(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))')]],
        //sexo: ['M'],
        estado_civil: [1],
        nacionalidades_id: [73],
        //curp: [''],
        telefono_contacto: [''],
        // email: [''],
        // nacimiento_estados_id: [23],
        // nacimiento_municipios_id: [1843],
        estados_id: [23],
        municipios_id: [1843],
        localidades_id: [201096],
        colonia: [''],
        calle: [''],
        no_exterior: [''],
        no_interior: [''],
        codigo_postal: [''],
        certificado_medico: [0],
        alergia: [0],
        discapacitado: [0],
        enfermedad_cronica: [0],
        descripcion_enfermedad_cronica: [''],
        descripcion_alergia: [''],
        seguro: ['NINGUNO'],
        emergencia_nombre: [''],
        emergencia_celular: [''],
        escuela_nombre: [''],
        escuela_domicilio: [''],
        escuela_estados_id: [23],
        escuela_sector: ['PUBLICO'],
        tutor_nombre: [''],
        tutor_domicilio: [''],
        tutor_telefono: [''],
        tutor_ocupacion: [''],
        acta_nacimiento: [0],
        curp_impreso:[0],
        certificado_preparatoria: [0],
        certificado_legalizado: [0],
        carta_conducta: [0],
        historial_academico: [0],
        fotografias: [0],
        beca_promedio: [0],
        beca_convenio: [0],
        documentos_observaciones: [''],
        carreras_planes_id:[''],
        periodos_escolares_id: [''],
        grupos_id: [''],
        matricula: [''],
        avatar: [''],
        foto: ['']
      })
    });

  
    

    this.niveles = [
      {id:1, texto:"1 Semestre"}
    ]

    this.crud.lista(this.parametros, 'carrera-plan?activo=1').subscribe(
      resultado => {
          this.carreras_planes = resultado.data;
      },
      error => {
      }
    );

    this.form_disponibilidades_horarios_docentes = {
      dias_semanas_id: ['1', [Validators.required]],
      hora_inicial: ['07:00:00', [Validators.required]],
      disponibilidad_total:[''],
      hora_final: ['08:00:00', [Validators.required]]
    };

    this.form_docentes_perfiles_materias = {
      materias_id: ["", [Validators.required]],
      nombre: [""],
      clave: [""],
      nivel: [""],
      carreras_planes: ['']
    };

    this.route.params.subscribe(params => {
      this.tieneid = params['id'];
    });



    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

  filtra_niveles()  {
    let  carrera_plan_id = this.dato.controls.carreras_planes_id.value;
    this.carreras_planes.forEach(cp => {
      if (cp.id==carrera_plan_id) {
        this.niveles = [];
        for (let index = 0; index <= (cp.carreras.numero_periodos - 1); index++) {
          this.niveles.push({id: (index + 1), texto:(index + 1)+' '+cp.carreras.tipos_periodos.nombre_para_mostrar});
        }
        return false;
      }
    });
  }

  filtra_materias() {
    this.materias = [];
    // console.log(this.dato.controls.nivel.value)
    this.crud.lista(this.parametros, 'materia?carreras_planes_id='+this.dato.controls.carreras_planes_id.value+'&nivel='+this.dato.controls.nivel.value).subscribe(
      resultado => {
        //console.log(resultado.data)
          this.materias = resultado.data;
      },
      error => {
      }
    );
  }

  /**
   * Este método agrega un formgrupo a un formarray, para crear un formulario dinamico
   * ejemplo <code>(click)="ctrl.agregar_form_array(ctrl.dato.controls.almacen_tipos_movimientos, form_almacen_tipos_movimientos)"</code>
   * @param modelo Nombre del modelo donde se guarda el dato obtenido
   * @param formulario Nombre del modelo donde se guarda el dato obtenido
   * @return void
   */
  agregar_form_array(modelo: FormArray, formulario, materias) {
    let materia_id = this.dato.controls.materias_id.value;
    // console.log(materias);
    if (materias.length>0) {
      materias.forEach(materia => {
        if (materia.id==materia_id) {
          formulario['materias_id'] =  materia_id;
          formulario['nombre'] =  materia.nombre;
          formulario['clave'] =  materia.clave;
          formulario['nivel'] = materia.nivel;
          formulario["carreras_planes"] = materia.carreras_planes;
          formulario["materias"] = materia;
          return false;
        }
      });
    }

    let existe = false;
    if (materia_id!="" && materia_id!=null) {
      this.dato.controls.docentes_perfiles_materias.value.forEach(element => {
        // console.log(materia_id, " MATERIAS - ID ", element.materias_id)
        if (element.materias_id==materia_id) {
          existe = true;
        }
      });

      if (!existe) {
        (<FormArray>modelo).push(this.fb.group(formulario));
        this.dato.controls.materias_id.patchValue('');
      } else {
        this.mensajeResponse.titulo = "Materias de perfil";
        this.mensajeResponse.texto = "Las materias sólo se deben agregar una vez";
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = "warning";
        this.mensaje(3);
      }
    } else {
      this.mensajeResponse.titulo = "Materias de perfil";
      this.mensajeResponse.texto = "Seleccione una materia para poder agregarla";
      this.mensajeResponse.mostrar = true;
      this.mensajeResponse.clase = "info";
      this.mensaje(3);
    }

    // console.log("MATERIA FIN: "+this.dato.controls.materias_id.value)
  }

  /**
     * Este método selecciona un valor de un select2 y lo pasa al modelo
     * @param valor valor del options del selec seleccionado
     * @param modelo  modelo donde se agrega el valor
     * @return void
     */
  // carrera_plan(valor: any, modelo, url: string = '', item) {
  //     if (url != '') {
  //       this.crud.lista(0, 0, url+'?carreras_planes_id='+this.dato.controls.personas_metadatos['controls']['carreras_planes_id'].value+'&periodos_escolares_id='+this.dato.controls.personas_metadatos['controls']['periodos_escolares_id'].value).subscribe(
  //           resultado => {
  //               resultado.data.forEach(element => {
  //                   if (!element.text)
  //                       element.text = element.nombre;
  //               });
  //               this.grupos = resultado.data;
  //           },
  //           error => {
  //           }
  //       );
  //     }
  // }

  /**
   * Este método selecciona un valor de un select2 y lo pasa al modelo
   * @param valor valor del options del selec seleccionado
   * @param modelo  modelo donde se agrega el valor
   * @return void
   */
  // plan(valor: any, modelo, carreras_planes: any[] = [], planes: any[] = []) {
  //   this.dato.controls.planes_pagos_id.setValue(planes[0].id); // id del plan de pago
  //   //let carrera_id:number = null;
  //   this.inscripcion = 0; this.reinscripcion = 0; this.colegiatura = 0;

  //   carreras_planes.forEach(element => {
  //     if(this.dato.controls.personas_metadatos.get('carreras_planes_id').value==element.id)
  //       this.carrera_id=element.carreras_id;
  //   });

  //   planes[0].planes_pagos_detalles.forEach(element => {
  //     if(this.carrera_id==element.carreras_id){
  //       this.inscripcion = element.articulos[0].importe; //Inscripcion
  //       this.reinscripcion = element.articulos[1].importe; //Reinscripcion
  //       this.colegiatura = element.articulos[2].importe; //Colegiatura
  //     }
  //   });
  //   if(this.dato.controls.becas_id.value=='' || this.dato.controls.becas_id.value==null){
  //     this.descripcion_beca = ''; this.beca_inscripcion = 0; this.beca_reinscripcion = 0; this.beca_colegiatura = 0;}
  //   if(this.dato.controls.personas_metadatos.get('carreras_planes_id').value==''){
  //     this.inscripcion = 0; this.reinscripcion = 0; this.colegiatura = 0;}

  // }

  /**
   * Este método selecciona un valor de un select2 y lo pasa al modelo
   * @param valor valor del options del selec seleccionado
   * @param modelo  modelo donde se agrega el valor
   * @return void
   */
  // beca(valor: any, modelo, carreras_planes: any[] = [], becas: any[] = []){
  //   this.descripcion_beca = '';
  //   this.beca_inscripcion = 0; this.beca_reinscripcion = 0; this.beca_colegiatura = 0;
  //   becas.forEach(element => {
  //     element.becas_detalles.forEach(elemento => {
  //       if(this.carrera_id==elemento.carreras_id){
  //         this.descripcion_beca = element.nombre+': '+element.descripcion;
  //         if(elemento.articulos_id==1)
  //           this.beca_inscripcion = elemento.importe; //Inscripcion
  //         if(elemento.articulos_id==2)
  //           this.beca_reinscripcion = elemento.importe; //Reinscripcion
  //         if(elemento.articulos_id==3)
  //           this.beca_colegiatura = elemento.importe; //Colegiatura
  //       }
  //     });
  //   });
  //   //console.log(this.dato.controls.becas_id.value)
  //   if(this.dato.controls.becas_id.value=='' || this.dato.controls.becas_id.value==null){
  //     this.descripcion_beca = ''; this.beca_inscripcion = 0; this.beca_reinscripcion = 0; this.beca_colegiatura = 0;}
  //   if(this.dato.controls.personas_metadatos.get('carreras_planes_id').value==''){
  //     this.inscripcion = 0; this.reinscripcion = 0; this.colegiatura = 0;}
  // }

  unchecked(entrada){
    if(entrada.value){
      entrada.setValue(1);
    } else {
      entrada.setValue(0);
    }
  }

  // mostrar notificaciones configuracion default, posicion abajo izquierda, tiempo 2 segundos
  public options = {
    position: ["bottom", "left"],
    timeOut: 2000,
    lastOnBottom: true
  };

  /**
   * Este método muestra los mensajes resultantes de los llamados de la api
   * @param cuentaAtras numero de segundo a esperar para que el mensaje desaparezca solo
   * @param posicion  array de posicion [vertical, horizontal]
   * @return void
   */
  mensaje(cuentaAtras: number = 6, posicion: any[] = ["bottom", "left"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };
    if (this.mensajeResponse.titulo == '')
      this.mensajeResponse.titulo = this.titulo;

    if (this.mensajeResponse.clase == 'alert')
      this.notificacion.alert(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'success')
      this.notificacion.success(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'info')
      this.notificacion.info(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'warning' || this.mensajeResponse.clase == 'warn')
      this.notificacion.warn(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'error' || this.mensajeResponse.clase == 'danger')
      this.notificacion.error(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

  }

}
